export  type ssgComponentStatus = 'basic' | 'primary' | 'success' | 'warning' | 'danger' | 'info' | 'control';
export  enum ssgGlobalLogicalPosition {
    TOP_START = "top-start",
    TOP_END = "top-end",
    BOTTOM_START = "bottom-start",
    BOTTOM_END = "bottom-end"
}
export  enum ssgGlobalPhysicalPosition {
    TOP_RIGHT = "top-right",
    TOP_LEFT = "top-left",
    BOTTOM_RIGHT = "bottom-right",
    BOTTOM_LEFT = "bottom-left"
}

export interface ssgIconConfig {
  icon: string;
  pack?: string;
  status?: ssgComponentStatus;
  options?: {
      [name: string]: any;
  };
}

export type ssgGlobalPosition = ssgGlobalPhysicalPosition | ssgGlobalLogicalPosition;
export type ssgDuplicateToastBehaviour = 'previous' | 'all';
export class ssgToastrConfig {
  /**
   * Determines where on the screen toast have to be rendered.
   * */
  position: ssgGlobalPosition;
  /**
   * Status chooses color scheme for the toast.
   * */
  status: ssgComponentStatus;
  /**
   * Duration is timeout between toast appears and disappears.
   * */
  duration: number;
  /**
   * Destroy by click means you can hide the toast by clicking it.
   * */
  destroyByClick: boolean;
  /**
   * If preventDuplicates is true then the toast with the same title, message and status will not be rendered.
   * Find duplicates behaviour determined by `preventDuplicates`.
   * The default `previous` duplicate behaviour is used.
   * */
  preventDuplicates: boolean;
  /**
   * Determines the how to threat duplicates.
   * */
  duplicatesBehaviour: ssgDuplicateToastBehaviour;
  limit?: number;
  /**
   * Class to be applied to the toast.
   */
  toastClass: string;
  /**
   * Determines render icon or not.
   * */
  hasIcon: boolean;
  /**
   * Icon name or icon config object that can be provided to render custom icon.
   * */
  icon: string | ssgIconConfig;
  /**
   * Icon pack to look for the icon in.
   * @deprecated Set pack via icon config object passed to icon property
   * @breaking-change 5.0.0
   * */
  iconPack: string;
  /**
   * Toast status icon-class mapping.
   * */

}
